<template>
  <figure>
    <router-link
      :to="{
        name: `book_detail`,
        params: { id: book.bookCode }
      }"
      class="book_link"
    >
      <img :src="book.thumbUrl" :alt="book.bookNm" />
      <figcaption>
        <cite>{{ book.bookNm }}</cite>
        <span>{{ book.author }}</span>
      </figcaption>
    </router-link>
  </figure>
</template>

<script>
export default {
  name: 'BaseGenre',

  props: {
    book: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
figure {
  width: 172px !important;
  height: auto;
  figcaption {
    margin-top: 15px;
    min-height: 80px;
    > cite,
    span {
      display: -webkit-box;
      width: 172px;
      margin-bottom: 3px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    cite {
      margin-bottom: 3px;
      // word-break: keep-all;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0.1px;
      font-size: 16px;
      color: #444444;
    }
    span {
      letter-spacing: 0.1px;
      line-height: 16px;
      font-size: 14px;
      color: #848484;
    }
  }
}
.book_link {
  display: block;
  img {
    object-fit: cover;
    max-height: 254px;
    width: 100%;
    aspect-ratio: auto 1 / 1.37;
    border-radius: 10px;
    box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.2);
  }
}
@media (max-width: 1024px) {
  figure {
    width: 151px !important;
    figcaption {
      cite {
        width: 151px;
      }
      span {
        width: 151px;
      }
    }
  }
}
@media (max-width: 768px) {
  figure {
    width: 138px !important;
    figcaption {
      margin-top: 10px;
      cite {
        width: 138px;
        margin-bottom: 5px;
        line-height: 16px;
        font-size: 14px;
      }
      span {
        width: 138px;
        line-height: 14px;
        font-size: 12px;
      }
    }
  }
}
@media (max-width: 480px) {
  figure {
    width: 123px !important;
    figcaption {
      margin-top: 7px;
      > cite,
      span {
        width: 123px;
        margin-bottom: 3px;
        line-height: 16px;
      }
      cite {
        font-weight: 600;
        font-size: 13px;
      }
      span {
        font-size: 9px;
        line-height: 12px;
      }
    }
  }
}
</style>
